import { render, staticRenderFns } from "./registrationBlock.vue?vue&type=template&id=c8cc7062&scoped=true&"
import script from "./registrationBlock.vue?vue&type=script&lang=js&"
export * from "./registrationBlock.vue?vue&type=script&lang=js&"
import style0 from "./registrationBlock.vue?vue&type=style&index=0&id=c8cc7062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cc7062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VDialog,VIcon,VSelect,VSwitch,VTextField,VTooltip})
